var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "change-rate-modal",
      attrs: {
        "close-on-click-modal": false,
        visible: _vm.show,
        title: "",
        width: "480px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        close: _vm.onChange,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("system::exchange-manager::change_rate"))),
      ]),
      _c(
        "el-form",
        {
          ref: "formType",
          staticClass: "type-body",
          attrs: { model: _vm.params, rules: _vm.rules, "label-width": "0" },
        },
        [
          _c("el-form-item", { attrs: { label: "", prop: "value" } }, [
            _c(
              "div",
              { staticClass: "exchange-info" },
              [
                _vm._v(
                  " 1 " +
                    _vm._s(_vm.$t("system::exchange-manager::dollar")) +
                    " = "
                ),
                _c("el-input-number", {
                  staticStyle: {
                    width: "180px",
                    margin: "0 4px",
                    "text-align": "left",
                  },
                  attrs: { controls: false, min: 0 },
                  model: {
                    value: _vm.params.value,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.params,
                        "value",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "params.value",
                  },
                }),
                _vm._v(
                  " " + _vm._s(_vm.$t("system::exchange-manager::rmb")) + " "
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSave },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }